/**
 * Stripe minimum charge amounts (major currency units).
 * @see https://docs.stripe.com/currencies#minimum-and-maximum-charge-amounts
 */
const STRIPE_MINIMUM_MAJOR: Record<string, number> = {
  cny: 4,
  usd: 0.5,
  eur: 0.5,
  gbp: 0.3,
  aud: 0.5,
  cad: 0.5,
  hkd: 4,
  sgd: 0.5,
  jpy: 50,
}

export const STRIPE_MIN_AMOUNT_CODE = "stripe_amount_too_low"

export function getStripeMinimumMajorAmount(currencyCode: string): number {
  const code = (currencyCode || "usd").toLowerCase()
  return STRIPE_MINIMUM_MAJOR[code] ?? 0.5
}

/** Cart totals in this storefront are major units (same as convertToLocale). */
export function isStripeAmountBelowMinimum(cart: {
  total?: number | null
  currency_code?: string | null
}): boolean {
  const total = Number(cart.total ?? 0)
  if (total <= 0) {
    return false
  }
  const min = getStripeMinimumMajorAmount(cart.currency_code || "usd")
  return total < min
}
